import { useState, useEffect, useMemo } from 'react';
import { DEFAULT_GOOGLE_SHEETS_URL } from '../constants';
import { handleLoadFromGoogleSheets } from '../utils/dataLoading';

export const useDataState = (visualizationCallbacks = {}) => {
  const [methodData, setMethodData] = useState({});
  const [experimentsMetadata, setExperimentsMetadata] = useState({});
  const [fileInfo, setFileInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [googleSheetsUrl, setGoogleSheetsUrl] = useState(DEFAULT_GOOGLE_SHEETS_URL);
  const [hasAutoLoaded, setHasAutoLoaded] = useState(false);
  const [availableSettings, setAvailableSettings] = useState([]);
  const [availableExperiments, setAvailableExperiments] = useState([]);

  useEffect(() => {
    if (!hasAutoLoaded) {
      setHasAutoLoaded(true);
      handleLoadFromGoogleSheets(googleSheetsUrl, {
        setIsLoading,
        setError,
        setMethodData,
        setExperimentsMetadata,
        setFileInfo,
        setSelectedMethod: visualizationCallbacks.setSelectedMethod || (() => {}),
        setSelectedModel: visualizationCallbacks.setSelectedModel || (() => {}),
        setComparisonModel: visualizationCallbacks.setComparisonModel || (() => {}),
        setSelectedMethodsForComparison: visualizationCallbacks.setSelectedMethodsForComparison || (() => {}),
        setAvailableSettings,
        setAvailableExperiments
      });
    }
  }, [hasAutoLoaded, googleSheetsUrl, visualizationCallbacks]);

  // Helper function to get methods filtered by settings
  const getFilteredMethods = useMemo(() => {
    return (selectedSettings) => {
      if (!selectedSettings || selectedSettings.length === 0) {
        return Object.keys(methodData);
      }
      return Object.keys(methodData).filter(key => {
        const metadata = experimentsMetadata[key];
        // Include methods whose setting matches selectedSettings, or methods with unknown setting
        return metadata && (selectedSettings.includes(metadata.setting) || metadata.setting === 'unknown');
      });
    };
  }, [methodData, experimentsMetadata]);

  return {
    methodData,
    setMethodData,
    experimentsMetadata,
    setExperimentsMetadata,
    fileInfo,
    setFileInfo,
    isLoading,
    setIsLoading,
    error,
    setError,
    googleSheetsUrl,
    setGoogleSheetsUrl,
    availableSettings,
    setAvailableSettings,
    availableExperiments,
    setAvailableExperiments,
    getFilteredMethods
  };
};
